import { Gradient } from "whatamesh";

const Mash = () => {
    const gradient = new Gradient();

    gradient.initGradient("#gradient-canvas");
}

export default Mash